import { IGeocodeHighwaySchema } from '../../../repositories/monolith-python/v2/geocode';
import { IOfferHighway } from '../../../types/reducers/offer';

export const mapHighway = (undergroundRaw: IGeocodeHighwaySchema, index: number): IOfferHighway => {
  const { id, name, distance, isDefault, uuid } = undergroundRaw;

  return {
    id,
    name,
    distance,
    isDefault: isDefault ?? index === 0,
    uuid,
  };
};
